import { deriveErrorResponse } from "../../../utils";
export class OrganizationDmpsFetchFailed extends Error {
    constructor(orgId, baseError) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OrganizationDmpsFetchFailed);
        }
        const apiErrorMessages = deriveErrorResponse(baseError);
        const detailMessage = apiErrorMessages.length > 0 ? `Details: ${apiErrorMessages.join(",")}` : "Please try again.";
        this.name = "OrganizationDmpsFetchFailed";
        this.message = `Failed to fetch DMPs for organization ${orgId}. ${detailMessage}`;
    }
}
//# sourceMappingURL=errors.js.map